import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_button = _resolveComponent("b-button");
  const _component_Loading = _resolveComponent("Loading");
  const _component_BillingForm = _resolveComponent("BillingForm");
  const _component_b_modal = _resolveComponent("b-modal");
  return _openBlock(), _createElementBlock("span", null, [_createVNode(_component_b_button, {
    class: "w-100",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.modalstate = true),
    variant: $props.btnColor,
    size: $props.btnSize
  }, {
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "btnContent", {}, () => [_cache[2] || (_cache[2] = _createTextVNode(" Open Modal ", -1))])], undefined, true),
    _: 3
  }, 8, ["variant", "size"]), _createVNode(_component_b_modal, {
    id: "credit-card-modal",
    title: ($props.billingrecord ? 'Edit' : 'Add') + ' Credit Card',
    modelValue: _ctx.modalstate,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.modalstate = $event),
    "no-close-on-backdrop": "",
    "no-close-on-esc": "",
    "ok-title": ($props.billingrecord ? 'Edit' : 'Add') + ' Card',
    "ok-variant": "success",
    "ok-disabled": !_ctx.form.billing.valid && _ctx.form.billing.cardedit && this.form.billing.cardedit > 0 || !_ctx.form.billingAddress.valid || _ctx.loading,
    size: "lg",
    onOk: $options.updateBilling
  }, {
    default: _withCtx(() => [_createVNode(_component_Loading, {
      loading: _ctx.loading
    }, null, 8, ["loading"]), !_ctx.loading ? (_openBlock(), _createBlock(_component_BillingForm, {
      key: 0,
      address: $props.address,
      states: $props.states,
      countries: $props.countries,
      billingrecord: $props.billingrecord,
      onUpdate: $options.setBilling
    }, null, 8, ["address", "states", "countries", "billingrecord", "onUpdate"])) : _createCommentVNode("", true)], undefined, true),
    _: 1
  }, 8, ["title", "modelValue", "ok-title", "ok-disabled", "onOk"])]);
}